"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const flags = [
    {
        token: 'YYYY',
        replaceWith: (date) => date.getFullYear().toString(),
    },
    {
        token: 'MM',
        replaceWith: (date) => (date.getMonth() + 1).toString().padStart(2, '0'),
    },
    {
        token: 'DD',
        replaceWith: (date) => date.getDate().toString().padStart(2, '0'),
    },
];
/*
 * Format the given date based on the given format string. Flags are replaced by
 * their respective values in the date.
 *
 * Supported flags:
 *
 * YYYY - Full year.
 * MM   - Zero padded month.
 * DD   - Zero padded day.
 *
 * @Param {Date} date     = The date to use for the resulting string.
 * @Param {string} format = The format to use for the resulting string.
 *
 * @Example
 *
 *   formatDate(new Date('2018-01-01'), 'YYYY-MM-DD')
 *   //=> "2018-01-01"
 */
function formatDate(date, format) {
    return flags.reduce((result, { token, replaceWith }) => result.replace(token, replaceWith(date)), format);
}
exports.formatDate = formatDate;
//# sourceMappingURL=format-date.js.map